import { Box, Stack } from '@mui/material';
import { Text } from '@telegram-apps/telegram-ui';
import { type FC } from 'react';
import { getColor } from '../../helpers/color';
import { VoiceState } from '../../types/voice';

const DOT_COLOR_MAP: Record<string, string> = {
  [VoiceState.LISTENING]: 'var(--tg-theme-button-color)',
  [VoiceState.PROCESSING]: getColor('ORANGE_600'),
  [VoiceState.REVIEW]: getColor('BLUE_600'),
  [VoiceState.SUCCESS]: 'var(--tg-theme-button-color)',
  [VoiceState.ERROR]: 'var(--tg-theme-destructive-text-color)',
};

interface VoiceModalHeaderProps {
  voiceState: string;
  stateLabel: string;
}

export const VoiceModalHeader: FC<VoiceModalHeaderProps> = ({
  voiceState,
  stateLabel,
}) => {
  const dotColor = DOT_COLOR_MAP[voiceState] ?? 'var(--tg-theme-button-color)';
  const isListening = voiceState === VoiceState.LISTENING;
  return (
  <Stack direction="row" alignItems="center" gap={1}>
    <Box
      sx={{
        width: 8,
        height: 8,
        borderRadius: '50%',
        background: dotColor,
        boxShadow: `0 0 10px ${dotColor}`,
        animation: isListening ? 'voicePulse 1s infinite' : 'none',
      }}
    />
    <Text
      style={{
        color: voiceState === VoiceState.REVIEW ? 'var(--tg-theme-text-color)' : 'var(--tg-theme-hint-color)',
        fontSize: voiceState === VoiceState.REVIEW ? 13 : 11,
        fontWeight: voiceState === VoiceState.REVIEW ? 700 : 400,
        letterSpacing: voiceState === VoiceState.REVIEW ? 0 : '0.08em',
        textTransform: voiceState === VoiceState.REVIEW ? 'none' : 'uppercase',
      }}
    >
      {stateLabel}
    </Text>
  </Stack>
  );
};
